export default __webpack_public_path__ + "static/media/spinner_dotted.bdaaae4e.svg";